import React from 'react';
import Edit from '../Edit';
import View from '../View';
import { Fields } from './constants';

const Settings = ({
  client, editMode = false, onChange, onClose,
}) => {
  if (editMode) {
    return (
      <Edit fields={Fields} client={client} onChange={onChange} name="setting" onClose={onClose} />);
  }
  return (<View fields={Fields} client={client} />);
};

export default Settings;
